import { render } from "./PlateformeCliniques.vue?vue&type=template&id=0bececc9&scoped=true"
import script from "./PlateformeCliniques.vue?vue&type=script&lang=js"
export * from "./PlateformeCliniques.vue?vue&type=script&lang=js"

import "./PlateformeCliniques.vue?vue&type=style&index=0&id=0bececc9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bececc9"]])

export default __exports__